/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Search/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Search({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Search",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Search.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-ZfSVMU': alignSelf,'--mt-2-ZfSVMU': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZfSVMU': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZfSVMU': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZfSVMU': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZfSVMU': opacity,'--w-10-ZfSVMU': typeof width === 'number' ? `${width}px` : width,'--h-11-ZfSVMU': typeof height === 'number' ? `${height}px` : height,'--f-12-ZfSVMU': fill,'--a-7-ZfSVMU': isAnimated ? animation : "none",'--sd-8-ZfSVMU': isAnimated ? strokeDashoffset : 0,'--sd-9-ZfSVMU': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Search.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M2 6a4 4 0 118 0 4 4 0 01-8 0zm4-6a6 6 0 103.476 10.89l2.817 2.817a1 1 0 001.414-1.414l-2.816-2.816A6 6 0 006 0z"
 style={{'--f-12-ZfSVMU': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}